class consentHelper {
  // --> Consent types required for Google's services:
  //               ad_storage - storage (such as cookies) related to advertising
  //             ad_user_data - consent for sending user data related to advertising to Google
  //       ad_personalization - sets consent for personalized advertising
  //        analytics_storage - storage (such as cookies) related to analytics e.g. visit duration
  //
  // --> Consent types only for non-Google tags:
  //  personalization_storage - storage related to personalization e.g. video recommendations
  //
  //    functionality_storage - storage that supports the functionality of the website or app e.g. language settings
  //         security_storage - storage related to security such as authentication functionality, fraud prevention, and other user protection
  //
  // functionality_storage and security_storage - in the European Union they are typically deemed to be strictly necessary storage and thus wouldn’t require consent at all.
  static get consentCategory() {
    return {
      None : 0,
      AnalyticsStorage : 1,
      AdStorage : 2,
      AdUserData : 4,
      AdPersonalization : 8
    }; // max. 32 bits
  }
  static get consentFlagsAll() {
    return this.consentCategory.AnalyticsStorage | this.consentCategory.AdStorage | this.consentCategory.AdUserData | this.consentCategory.AdPersonalization;
  }
  static get consentChoice() {
    return {
      Granted: "granted",
      Denied: "denied"
    };
  }
  static get key() {
    return "consent";
  }

/*
  function encodeConsent(consentState) {
    var result = consentCategory.None;
    if (consentState.analytics_storage == consentChoice.Granted)
      result = result | consentCategory.AnalyticsStorage;
    if (consentState.ad_storage == consentChoice.Granted)
      result = result | consentCategory.AdStorage;
    if (consentState.ad_user_data == consentChoice.Granted)
      result = result | consentCategory.AdUserData;
    if (consentState.ad_personalization == consentChoice.Granted)
      result = result | consentCategory.AdPersonalization;
    return result;
  }
*/

  static #decodeConsent(consentFlags) {
    let result = {};
    if (consentFlags & this.consentCategory.AnalyticsStorage)
      result.analytics_storage = this.consentChoice.Granted;
    if (consentFlags & this.consentCategory.AdStorage)
      result.ad_storage = this.consentChoice.Granted;
    if (consentFlags & this.consentCategory.AdUserData)
      result.ad_user_data = this.consentChoice.Granted;
    if (consentFlags & this.consentCategory.AdPersonalization)
      result.ad_personalization = this.consentChoice.Granted;
    return result;
  }

  static #getCookie(key,defValue=null) {
    // Split cookie string and get all individual name=value pairs in an array
    let cookieArr = document.cookie.split(";");
    // Loop through the array elements
    for (let i = 0; i < cookieArr.length; i++) {
      let cookiePair = cookieArr[i].split("=");
      /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
      if (this.key == cookiePair[0].trim())
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
    }
    // Return default value if not found
    return defValue;
  }

  static #setCookie(key,value) {
    let date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    let cookie = this.key + '=' + value + ';path=/;expires=' + date.toGMTString();
    if (window.location.protocol == "https:")
      cookie += ';secure';
    let hostname = window.location.hostname;
    const prefix = 'www.';
    if (hostname.startsWith(prefix))
      hostname = hostname.substr(prefix.length);
    if (hostname.includes('.'))
      cookie += ';domain=' + hostname;
    document.cookie = cookie;
  }


  static consentChanged(value) {
    // value je buď consentFlags nebo tlačítko formuláře se souhlasem
    let consentFlags = 0;
    if (value.form==undefined)
      consentFlags = parseInt(value) || 0
    else {
      let $checkboxes = $('input[type="checkbox"]', '#' + this.key);
      $checkboxes.each(function() {
        let value = parseInt(this.value) || 0;
        if (value>0 && this.checked)
          consentFlags = consentFlags | value;
      });
    }

    this.#setCookie(this.key,consentFlags);

    var consentState = this.#decodeConsent(consentFlags);
    gtag('consent', 'update', consentState);
    window.dataLayer.push({
      event: "update_consent"
    });
    $('.' + this.key).hide();
  }

  static showConsent() {
    let consentFlags=parseInt(this.#getCookie(this.key,"0")) || 0;
    $('input[type="checkbox"]', '#' + this.key).each(function() {
      let value = parseInt(this.value) || 0;
      if (value>0)
        this.checked = (value & consentFlags) > 0;
    });
    $('.' + this.key).show();
  }

  static autoShow() {
    let consentFlags=this.#getCookie(this.key,null);
    if (consentFlags===null) {
      this.showConsent();
    }
  }

}

consentHelper.autoShow();